import React, {Component} from 'react'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import {values} from 'lodash'
import {ButtonGroup, Glyphicon, Table} from 'react-bootstrap'
import queryString from 'query-string'
import DocumentTitle from "react-document-title"

import {createSupplier, removeSupplier, updateSupplier} from '../ducks/suppliers'
import AdminNav from '../components/AdminNav.jsx'
import {docListStyle} from '../containers/PageStyles'
import {cleanString, l} from '../../lib/Tools'
import Button from '../components/Button.jsx'
import isObjectEqual from '../../lib/isObjectEqual.js'
import {getFromQuery, getSuppliers, getActivitiesPerSupplier} from '../selectors'
import {replaceQuery} from '../lib/AppTools.js'
import {getText, getTextWithTokens} from '../lib/text.js'

/** sorting and filtering activities * */

function sortSuppliers(col: string, direction: "ASC"|"DESC"|"NONE", list: Object[]): Object[] {
  return list.sort((a, b) => {
    if (direction === "ASC") {
      const comparison = (a[col].replace(/\s/g, '') || " ").localeCompare(b[col].replace(/\s/g, '') || "")
      return comparison || (a.name || " ").localeCompare(b.name || " ")
    }
    else if (direction === "DESC") {
      const comparison = (b[col].replace(/\s/g, '') || " ").localeCompare(a[col].replace(/\s/g, '') || " ")
      return comparison || (a.name || " ").localeCompare(b.name || " ")
    }

    return (a.name || " ").localeCompare(b.name || " ")
  })
}
function filterByName(term, list) {
  if (!term || term.length === 0 || term === "ALL") { return list }
  const cleanTerm = cleanString(term).replace(/\s/g, '')
  return list.filter((row) => (
    cleanString(row.name).replace(/\s/g, '').indexOf(cleanTerm) >= 0
  ))
}

function mangleSuppliers(suppliers, filter, sortColumn, sortDirection) {
  return sortSuppliers(
    sortColumn, 
    sortDirection, 
    filterByName(filter, suppliers))
}


/** Activity picker
 * choose an activity, may be edit it
 * as close to stateless as posible
 * activitiesList needs only id, name and city
 * selectedActvity must be the whole document
 */

type SuppliersPageProps = {
  suppliers: Object, 
  onUpdate: (string, string, any) => void, 
  onSupplierCreate: (string, string => void) => void,
  suppliersActivities : { [string]: Object[] }, 
  query: {
    search: ?string,
    sortColumn: ?string,
    sortDirection: "ASC"|"DESC"
  }
}

const mapStateToProps = (state, props) => ({
  suppliers: getSuppliers(state, props), 
  suppliersActivities : getActivitiesPerSupplier(state, props), 
  query: {
    search: getFromQuery(state, props)("search") || "",
    sortDirection: getFromQuery(state, props)("sortDirection") || "ASC",
    sortColumn: getFromQuery(state, props)("sortColumn") || "name" 
  }
})

const mapDispatchToProps = (dispatch) => ({
  onUpdate: (id, k, v) => dispatch(updateSupplier(id, {[k]: v})), 
  onSupplierCreate: (name, idCallback) => dispatch(createSupplier({name}, idCallback)),
  remove: id => dispatch(removeSupplier(id)), 
})

/**
 * 
 */
class SuppliersPage extends React.PureComponent {
  props: SuppliersPageProps;  

  handleSupplierCreate() {
    const n = prompt(getText("Nombre"))
    if (n) this.props.onSupplierCreate(n, (id) => this.open(id)) 
  }

  handleSort(sortColumn) {
    if (sortColumn === this.props.query.sortColumn) {
      replaceQuery(browserHistory, this.props.query, { 
        sortDirection: this.props.query.sortDirection === "ASC" ? "DESC" : "ASC" 
      })
    }
    else {
      replaceQuery(browserHistory, this.props.query, { 
        sortColumn, 
        sortDirection: (sortColumn === "creation" || sortColumn === "modification" ? "DESC" : "ASC")
      })
    }
  }
  
  handleFilter(search) {
    replaceQuery(browserHistory, this.props.query, { search })
  }
  
  open(id) {
    const back = browserHistory.getCurrentLocation().pathname + browserHistory.getCurrentLocation().search
    browserHistory.push(l(`/private/supplier/${encodeURIComponent(id)}?${queryString.stringify({ back })}`)) 
  }

  remove(id) {
    this.props.remove(id) 
  }

  handleActivityChange(id, k, v) {
    this.props.onUpdate(id, k, v) 
  }

  render() {
    const { search, sortColumn, sortDirection } = this.props.query

    // I add a calculated field, activitiesNumber, to each item in the list
    // i need it to be a string bc sort function uses localCompare
    const list = mangleSuppliers(
      values(this.props.suppliers) 
        .map(supplier => ({ ...supplier, __activitiesNumber: this.props.suppliersActivities[supplier._id].length.toString() })), 
      search, 
      sortColumn, 
      sortDirection)

    const MyTh = ({label, col}) => (
      <th
        onClick={() => this.handleSort(col)} 
        style={{ textDecoration: sortColumn === col ? "underline" : "none", cursor: "pointer" }}
      >
        <Glyphicon glyph="sort" />{label}
      </th>
    )

    return (
      <div 
        style={docListStyle()} 
        className="normal"
      >
        <DocumentTitle title= {`Tripmaker ${getText("Proveedores")}`} />
        <AdminNav active="suppliers" />

        <div style={{ zIndex:20, backgroundColor: "white", top: 0, position: "sticky" }}>
          <Button 
            onClick={() => this.handleSupplierCreate()}
            style={{marginRight: 5, marginTop: 5, marginBottom: 5}}
          >
            <Glyphicon glyph="plus" />{" "}
            {getText("Nuevo proveedor")}
          </Button>
          
          <label htmlFor="SupplierFilter">{getText("Filtra por nombre")}:</label>
          <input 
            value={search} 
            onChange={evt => this.handleFilter(evt.target.value)} 
          />
        </div>

        <Table bordered striped>
          <thead style={{ height: 35, position: "sticky", top: 38, background: "white", zIndex: 20 }} >
            <tr>
              <th />
              <MyTh col="name" label={getText("Nombre")} />
              <MyTh col="contactPerson" label={getText("Nombre contacto")} />
              <th>{getText("Teléfono")}</th>
              <MyTh col="email" label={getText("Correo electrónico")} />
              <MyTh col="__activitiesNumber" label={getText("Nº de actividades")} />
            </tr>
          </thead>
          <tbody>
            {
              list.map(supplier => (
                <tr key={supplier._id}>
                  <td style={{width: 80}}>
                    <ButtonGroup>
                      <Button 
                        bsSize="xsmall"
                        style={{color: "red"}}
                        glyph="remove"
                        onClick={() => {
                          if (confirm(getTextWithTokens("delete_supplier", [supplier.name]))) 
                            this.remove(supplier._id) 
                        }}
                      />
                      <Button 
                        bsSize="xsmall"
                        glyph="pencil"
                        onClick={() => this.open(supplier._id)}
                      >
                        {getText("editButton")}
                      </Button>
                    </ButtonGroup>
                  </td>
                  <td style={{ width: 100 }}>{supplier.name}</td>
                  <td style={{ width: 100 }}>{supplier.contactPerson}</td>
                  <td style={{ width: 80 }}>{supplier.phoneNumber}</td>
                  <td style={{ width: 80 }}>{supplier.email}</td>
                  <td style={{ width: 40 }}>{supplier.__activitiesNumber}</td>
                  
                </tr>
              ))
            }
          </tbody>
        </Table>

      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SuppliersPage)
